module.exports = __webpack_public_path__ + "img/Teilzerstört.8308fa71.svg";